module.exports = __webpack_public_path__ + "static/media/new-alternatives-title.fd45a488.png";